/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * **INACTIVE**  The Booking is currently NOT being synced with Triton. In this state it can be set to ACTIVE.  **ACTIVE**  The Booking is currently being synced with Triton. Once set to active it cannot be unset, except for moving to DELETED.  **DELETED**  The Booking has been marked as deleted on Triton and it will no longer be able to be synced as it no longer exists on Triton.   * `INACTIVE` - Inactive * `ACTIVE` - Active * `DELETED` - Deleted
 * @export
 * @enum {string}
 */
export enum TritonBookingMetadataStateEnum {
    Inactive = 'INACTIVE',
    Active = 'ACTIVE',
    Deleted = 'DELETED'
}



